import React, { memo } from 'react';

import { DayWeekType } from '../types';
import CalendarContainer from './calendarContainer';
import CalendarGridDayWeek from './calendarGridDayWeek';
import CalendarHeaderDayWeek from './calendarHeaderDayWeek';
import CalendarTaskList from './calendarTaskList';

interface ICalendarDayWeek {
    type: DayWeekType;
}

const CalendarDayWeek: React.FC<ICalendarDayWeek> = ({ type }) => {
    return (
        <>
            <CalendarHeaderDayWeek typeDayWeek={type} />
            <CalendarContainer>
                <CalendarGridDayWeek typeGrid={type} />
                <CalendarTaskList typeDayWeek={type} />
            </CalendarContainer>
        </>
    );
};

export default memo(CalendarDayWeek);
